import React, { ForwardedRef, forwardRef, useImperativeHandle } from 'react';
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import Config from '@bonanza-social/toolkit/config';
import { RecaptchaRef } from './Recaptcha.types';

function InnerRecaptcha(_: unknown, ref: ForwardedRef<RecaptchaRef>) {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useImperativeHandle(
    ref,
    () => ({
      getToken: () => executeRecaptcha?.('login'),
    }),
    [executeRecaptcha],
  );

  return null;
}

InnerRecaptcha.displayName = 'InnerRecaptcha';

const RecaptchaComponent = forwardRef(InnerRecaptcha);
RecaptchaComponent.displayName = 'RecaptchaComponent';

const Recaptcha = forwardRef<RecaptchaRef>((_, ref) => (
  <GoogleReCaptchaProvider
    useEnterprise
    reCaptchaKey={Config.RECAPTCHA_KEY ?? ''}
  >
    <RecaptchaComponent ref={ref} />
  </GoogleReCaptchaProvider>
));
Recaptcha.displayName = 'Recaptcha';

export default Recaptcha;
